import axios from 'axios';
import { Providers } from '@microsoft/mgt-element';
import { Msal2Provider } from '@microsoft/mgt-msal2-provider';
import { jwtDecode } from 'jwt-decode';
import { BASE_URL } from './constants';

const apiClient = axios.create({
  baseURL: `${BASE_URL}/api/`,
});

const isTokenExpired = (token: string): boolean => {
  const decodedToken: any = jwtDecode(token);
  const currentTime = Math.floor(Date.now() / 1000);
  return decodedToken.exp < currentTime;
};

apiClient.interceptors.request.use(async (config) => {
  try {
    let token = await Providers.globalProvider.getAccessToken();

    if (token && isTokenExpired(token)) {
      console.warn('Access token has expired, redirecting to login');
      const provider = Providers.globalProvider as Msal2Provider;
      await provider.login();
      token = await Providers.globalProvider.getAccessToken();
    }

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      console.warn('No access token found');
      const provider = Providers.globalProvider as Msal2Provider;
      await provider.login();
      return Promise.reject(new Error('Redirecting to login'));
    }
  } catch (error) {
    console.error('Error getting access token:', error);
    const provider = Providers.globalProvider as Msal2Provider;
    await provider.login();
    return Promise.reject(new Error('Redirecting to login'));
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

export default apiClient;
